import React from 'react';
import { Info, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import type { IntegrationLog } from '../../types/integrations';

interface IntegrationLogsProps {
  integrationId?: string;
}

const IntegrationLogs: React.FC<IntegrationLogsProps> = ({ integrationId }) => {
  // Mock logs data
  const logs: IntegrationLog[] = [
    {
      id: '1',
      integrationId: '1',
      type: 'success',
      message: 'Conexão estabelecida com sucesso',
      timestamp: new Date()
    },
    {
      id: '2',
      integrationId: '1',
      type: 'info',
      message: 'Iniciando sincronização',
      timestamp: new Date()
    },
    {
      id: '3',
      integrationId: '1',
      type: 'error',
      message: 'Falha ao processar webhook',
      details: { error: 'Invalid signature' },
      timestamp: new Date()
    }
  ];

  const getIcon = (type: IntegrationLog['type']) => {
    switch (type) {
      case 'info':
        return <Info className="h-5 w-5 text-blue-500" />;
      case 'warning':
        return <AlertTriangle className="h-5 w-5 text-yellow-500" />;
      case 'error':
        return <XCircle className="h-5 w-5 text-red-500" />;
      case 'success':
        return <CheckCircle className="h-5 w-5 text-green-500" />;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">
          Logs da Integração
        </h3>
      </div>

      <div className="p-4">
        <div className="space-y-4">
          {logs
            .filter(log => !integrationId || log.integrationId === integrationId)
            .map((log) => (
              <div
                key={log.id}
                className="flex items-start space-x-3 text-sm"
              >
                {getIcon(log.type)}
                <div className="flex-1">
                  <p className="font-medium text-gray-900">
                    {log.message}
                  </p>
                  <p className="text-gray-500">
                    {log.timestamp.toLocaleString()}
                  </p>
                  {log.details && (
                    <pre className="mt-2 text-xs bg-gray-50 p-2 rounded">
                      {JSON.stringify(log.details, null, 2)}
                    </pre>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default IntegrationLogs;